export default "__VITE_ASSET__DEXh8L_h__"